<template>
  <login-layout :title="layoutTit">
    <div class="inivite-join-result">
      <a-form>
        <a-form-item>
          <span>{{ inviteuser }}</span>{{ $t('message["1587"]') }}
        </a-form-item>
        <a-form-item>
          <h2 class="invite-company-name">
            {{ comname }}
          </h2>
        </a-form-item>
        <a-form-item>
          <!-- 并成为该组织<strong>管理员</strong> -->
          <p>{{ $t('message["1096"]') }}？</p>
        </a-form-item>
        <a-form-item class="invite-re-btn">
          <a-button
            class="login-btn"
            type="primary"
            @click="submitForm"
          >
            {{ $t('message["597"]') }}
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            class="login-btn"
            @click="resetForm"
          >
            {{ $t('message["1448"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </login-layout>
</template>
<script>
import LoginLayout from '@/components/pc/account/LoginLayout'
import { mapActions, mapState } from 'vuex'
export default {
  'name': '',
  components: {
    LoginLayout
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([]),
    comname () {
      return this.$route.query.comname
    },
    inviteuser () {
      return this.$route.query.inviteuser
    },
    invitecode () {
      return this.$route.query.invitecode
    },
    layoutTit () {
      return this.$t('message["1381"]')
    }
  },
  methods: {
    ...mapActions('organization/inviteJoin', ['ajaxLastJoin']),
    async submitForm (formName) {
      const chain = await this.ajaxLastJoin()
      chain.params({ invitecode: this.$route.query.invitecode })
        .onSuccess((raw, res) => {
          this.$router.push({ name: 'OrgIndex' })
        })
        .fetch()
    },
    resetForm (formName) {
      // this.$router.push({ path: '/organization/index' })
      this.$router.push({ name: 'OrgIndex' })
    }
  }
}
</script>

<style lang="scss" scoped >

.inivite-join-result::v-deep {
  .login-btn {
    display: block;
    width: 100%;
  }

  .ant-row {
    margin: 0;
    text-align: center;
  }

  .el-form-item__content {
    line-height: 24px;

    .invite-company-name {
      line-height: 32px;
      font-weight: bold;
      font-size: 18px;
    }
  }

  .invite-re-btn {
    margin: 48px 0 24px;
  }
}
</style>
